import $api from "@/zapi-frontend/shared/api/axios";

export async function updateFeaturePermission(featurePermissionLevel: number, signal?: AbortSignal) {
  const response = await $api.post("/auth/update-feature-permission", { featurePermissionLevel }, { signal });
  return response.data;
}
